// extracted by mini-css-extract-plugin
export default {"tab-class":"SensitiveKeyword_tab-class__-iQ+a"};